<template>
  <div
    :class="{
      'card-header--with-header': header,
      'card-header--is-searching': isSearching
    }"
    class="card-header"
    data-tid="card-header"
  >
    <v-text-field
      :value="value"
      :placeholder="header || placeholder"
      :append-icon="action"
      :disabled="forCampaign ? !editMode : !action"
      :hide-details="hideDetails"
      :rules="rules"
      class="card-header__header"
      color="secondary"
      @input="$emit('input', $event)"
      @click:append="$emit('toggleEditMode')"
    />
    <span v-if="subheader" class="card-header__subheader caption grey--text">
      {{ subheader }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      required: false,
      default: null
    },
    subheader: {
      type: String,
      required: false,
      default: null
    },
    action: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: String,
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false
    },
    forCampaign: {
      type: Boolean,
      required: false,
      default: false
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isSearching() {
      return this.action == "search" && !!this.value;
    }
  }
};
</script>

<style lang="scss">
.card-header {
  position: relative;
  .v-input--is-disabled:not(.v-input--is-readonly) .v-icon.v-icon--disabled {
    opacity: 1;
    color: rgba(0, 0, 0, 0.54) !important;
    pointer-events: auto;
  }
  .v-text-field.v-input--is-disabled .v-input__slot::before {
    border-image: none !important;
  }
}
.card-header--with-header .card-header__header {
  .v-text-field__slot {
    input {
      &[disabled],
      &:not(:focus)::placeholder {
        color: inherit;
      }
    }
  }
}
.card-header--is-searching .card-header__header {
  .v-input__icon.v-input__icon--append {
    i.v-icon {
      color: #2bc176;
    }
  }
}
.card-header__header--no-margin {
  margin-bottom: 0;
}
.card-header__subheader {
  position: absolute;
  right: 0;
  top: 20px;
}
</style>
